import React from 'react';

export const Logo = () => {
    return (
        <span className={'font_logo'}>Info<strong>Auto</strong></span>
        
    )
}
